<template>
    <div class="guest">
        <div class="guest-list-title" :class="{line: config.topLine}">
            <h3 class="list-title-txt" :class="{bold: config.bold}">{{config.title}}</h3>
            <div class="list-more" v-if="config.more">
                <div class="list-more-txt">{{config.more.title}}</div>
                <a-icon type="right" />
            </div>
        </div>
        <ul class="guest-list">
            <li class="guest-item" :class="{line: config.itemLine}" v-for="(a, i) in config.list" :key="i">
                <div class="guest-avatar" :style="{backgroundImage: `url(${a.speaker_avatar||a.avatar})`}"></div>
                <div class="guest-txt">
                    <div class="guest-name">{{a.speaker||a.name}} <span>{{a.title}}</span></div>
                    <div class="guest-duty">{{a.speaker_org||a.company}} <span>{{a.duty}}</span></div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "guest-list",
        props: {
            config: {
                type: Object,
                default() {
                    return {}
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .guest-list-title {
        display: flex;
        align-items: center;
        &.line {
            border-bottom: var(--border);
        }
    }
    .list-title-txt {
        flex: 1;
        height: 36px;
        line-height: 36px;
        &.bold {
            font-weight: 600;
        }
    }
    .list-more {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        color: var(--light-font-color);
    }
    .guest-item {
        display: flex;
        padding: 10px 0;
        &.line {
            border-bottom: var(--border);
        }
    }
    .guest-avatar {
        flex-shrink: 0;
        margin-right: 10px;
        width: 60px;
        height: 60px;
        background: var(--back-light-color) center no-repeat;
        background-size: cover;
    }
    .guest-txt {
        flex: 1;
        color: var(--title-font-color);
        line-height: 1.5;
        font-size: 14px;
        span {
            font-size: 12px;
            color: var(--tip-font-color);
        }
    }
    .guest-duty {
        margin-top: 6px;
        font-size: 12px;
    }
</style>
